/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/svg/logo.svg';
import './style.scss';
import Utils from '../../redux/utils';
import { NotificationOutlined } from '@ant-design/icons';
import { FeedBackDialog } from '../../components';
import { Button } from 'antd';

const appRoute = 'app/';

const SideBar = () => {
  const [active, setActive] = useState<null | number>(null);
  const [activeItem, setActiveItem] = useState('');
  const [feedback, setFeedBack] = useState(false);
  const sideMenu = Utils.getSideMenu();
  const feedbackBtn = () => {
    setFeedBack(!feedback);
  };
  const handleToggle = (index: any) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };

  // const userPermissions = Utils.getCurrentMenu();
  return (
    <>
      <header className="page-header">
        <nav>
          <div className="card">
            <div className="card-body">
              <div className="app-logo">
                <img src={Logo} alt="React Logo" />
              </div>
              {sideMenu &&
                sideMenu.map((menuItem: any) => {
                  return (
                    <AccordionItem
                      key={menuItem?.id}
                      active={active}
                      handleToggle={handleToggle}
                      setActiveItem={setActiveItem}
                      activeItem={activeItem}
                      menuItem={menuItem}
                    />
                  );
                })}
            </div>
          </div>
        </nav>
        {/*<div
          className="header-bottom carret-button-bottom"
          onClick={() => setbottomSheetOpen((prevState) => !prevState)}
        >
          <img src="./asset/User.png" className="header-bottom-user-image" />
          <div className="bottom-user-detail-container">
            <h6>Saira Fasya</h6>
            <h6>Brand Admin</h6>
          </div>
          <div>
            {bottomSheetOpen ? (
              <img src="asset/svg/carret-up.svg" alt="arrow-up" />
            ) : (
              <img src="asset/svg/carret-down.svg" alt="arrow-down" />
            )}
          </div>
            </div> */}
      </header>
    </>
  );
};

const AccordionItem = (props: any) => {
  const contentEl = useRef<any>();
  const { handleToggle, active, menuItem, activeItem, setActiveItem } = props;
  // eslint-disable-next-line no-unused-vars
  const { routeName, id, hasChild, childRouteName, icon } = menuItem;

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentActivePath = location.pathname.split('/');
    setActiveItem(currentActivePath[currentActivePath.length - 1]);
  }, []);

  const onPressMenItem = (item: any) => {
    setActiveItem(item.routeName);
    navigate(`/${appRoute}${item.path}`);
  };

  const onSelectMenu = (id: any, child: any) => {
    handleToggle(id);
    onPressMenItem(child && child[0]);
  };

  return (
    <div className="rc-accordion-card">
      <div className="rc-accordion-header">
        <div
          className={`rc-accordion-toggle p-3 ${active === id ? 'active' : ''}`}
          onClick={() => hasChild && onSelectMenu(id, childRouteName)}
        >
          <div>
            <img src={icon} alt={routeName} width={15} />
            <h5 className="rc-accordion-title table-title1-hover">
              {routeName}
            </h5>
          </div>
          {hasChild && <i className="fa fa-chevron-down rc-accordion-icon"></i>}
        </div>
      </div>
      <div
        ref={contentEl}
        className={`rc-collapse ${active === id ? 'show' : ''}`}
        style={
          active === id
            ? { height: contentEl.current.scrollHeight }
            : { height: '0px' }
        }
      >
        {hasChild &&
          childRouteName.map((item: any) => (
            <div className="rc-accordion-body" key={item?.id}>
              <h6
                className={`rc-accordion-subtitle  ${
                  activeItem === item.routeName
                    ? 'activeMenuItem'
                    : 'table-title1-hover'
                }  vertical-line`}
                onClick={() => onPressMenItem(item)}
              >
                {item.routeName}
              </h6>
            </div>
          ))}
      </div>
    </div>
  );
};
export default SideBar;
